export const categoryList = [
  {
    slug: 'mingxing-tafang',
    name: '明星塌房',
    description: '顶流明星翻车现场，塌房猛料一网打尽',
    icon: 'ri-vip-crown-line',
    count: 12860,
    videoCount: 5632,
    todayUpdate: 38,
  },
  {
    slug: 'wanghong-heiliao',
    name: '网红黑料',
    description: '网红博主翻车合集，人设崩塌全记录',
    icon: 'ri-user-unfollow-line',
    count: 9540,
    videoCount: 4120,
    todayUpdate: 56,
  },
  {
    slug: 'fancha-shipin',
    name: '反差视频',
    description: '台前幕后两副面孔，颠覆认知的真相',
    icon: 'ri-contrast-2-line',
    count: 7230,
    videoCount: 3890,
    todayUpdate: 27,
  },
  {
    slug: 'zongyi-baoliao',
    name: '综艺爆料',
    description: '综艺节目黑幕揭秘，导演组不敢播的片段',
    icon: 'ri-tv-line',
    count: 5610,
    videoCount: 2450,
    todayUpdate: 19,
  },
  {
    slug: 'chigua-shequ',
    name: '吃瓜社区',
    description: '瓜友交流讨论区，全民一起吃瓜',
    icon: 'ri-chat-smile-2-line',
    count: 18420,
    videoCount: 0,
    todayUpdate: 145,
  },
];

export interface CategoryItem {
  slug: string;
  name: string;
  description: string;
  icon: string;
  count: number;
  videoCount: number;
  todayUpdate: number;
}